import React from 'react';
import './whatWeDoSection.scss';
import useIsMobile from '../../utils/useMobile';
import WhatWeDoPrimary from '../../images/what-we-do-primary.png';
import WhatWeDoSecondary from '../../images/what-we-do-secondary.png.png';

const items = [
  {
    heading: 'Expert Technicians',
    subHeading:
      'Our team of skilled technicians is dedicated to providing top-notch repair services for all household issues.',
  },
  {
    heading: 'Reliable Solutions',
    subHeading:
      'We ensure timely and efficient solutions to restore the functionality of your household appliances and systems.',
  },
  {
    heading: 'Affordable Services',
    subHeading: 'We offer competitive pricing without compromising on the quality of our services.',
  },
  {
    heading: 'Customer Satisfaction',
    subHeading:
      'Our goal is to build lasting relationships with our customers through transparent and reliable services.',
  },
];

export const WhatWeDoSection = () => {
  const isMobile = useIsMobile();
  return (
    <div className={'what-we-do'}>
      <div className={'container'}>
        <div className={'container__left'}>
          {isMobile ? (
            <div className={'container__left__img'} style={{ display: 'flex', alignItems: 'flex-start' }}>
              <img src={WhatWeDoSecondary} style={{ marginTop: 100, marginBottom: 30, zIndex: 1 }} />
            </div>
          ) : (
            <div className={'container__left__img'} style={{ display: 'flex', alignItems: 'flex-start' }}>
              <img
                src={WhatWeDoSecondary}
                style={{ zIndex: 0, height: 500, width: 700, objectFit: 'contain' }}
              />
              {/* <img src={WhatWeDoPrimary} style={{ position: 'relative', marginRight: '-80px', zIndex: 1 }} /> */}
            </div>
          )}
        </div>
        <div className={'container__right'}>
          <span id={'section-heading'}>What We Do</span>
          <h1>Comprehensive Repair Solutions for Your Home</h1>
          <p>
            At Repair Pros, we specialize in providing comprehensive repair solutions for all your household
            needs. From minor fixes to major overhauls, our experienced team is here to ensure your home runs
            smoothly.
          </p>

          <div className={'container__right__solutions'}>
            {items.map((item, index) => (
              <div key={index} className={'container__right__solutions__solution'}>
                <div className="container__row">
                  <div className="container__box" />
                  <div className={'container__right__solutions__solution_content'}>
                    <h3>{item.heading}</h3>
                    <p>{item.subHeading}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
